// English Language Pack
export default {
  // 检测部位
  part: {
    '车头': 'Front',
    '发动机舱': 'Engine Compartment',
    '左前车身': 'Left Front Body',
    '左前内饰': 'Left Front Interior',
    '左后车身': 'Left Rear Body',
    '左后内饰': 'Left Rear Interior',
    '车尾': 'Rear',
    '后备箱内部': 'Trunk Interior',
    '右后车身': 'Right Rear Body',
    '右后内饰': 'Right Rear Interior',
    '右前车身': 'Right Front Body',
    '右前内饰': 'Right Front Interior',
    '机电': 'Mechanical & Electrical',
    '新能源检测': 'New Energy Vehicle Inspection',
    '骨架': 'Skeleton',
    '外观': 'Exterior',
    '内饰': 'Interior',
    '其它': 'Others',
    '其他': 'Others',
    '水渍残留点': 'Water Stains',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': 'Minor Damage',
    '严重损伤': 'Severe Damage',
    '预检异常': 'Abnormal Pre-Inspection',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': 'No accident damage to structural and reinforcing components of the vehicle.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'No accident damage to structural components; slight accident damage to reinforcing components.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'No accident damage to structural components; severe accident damage to reinforcing components.',
    '车辆结构件有因事故造成的损伤': 'Accident damage to structural components.',
    '外观极差': 'Extremely Poor Exterior Condition',
    '内饰极差': 'Extremely Poor Interior Condition',
    '外观较差': 'Poor Exterior Condition',
    '内饰较差': 'Poor Interior Condition',
    '外观一般': 'Average Exterior Condition',
    '内饰一般': 'Average Interior Condition',
    '外观较好': 'Good Exterior Condition',
    '内饰较好': 'Good Interior Condition',
    '外观准新': 'Like-New Exterior Condition',
    '内饰准新': 'Like-New Interior Condition',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': 'Left Front Headlight',
    '左前雾灯': 'Left Front Fog Lamp',
    '前底盘': 'Front Underbody',
    '前保险杠': 'Front Bumper',
    '中网': 'Grille',
    '发动机舱盖外侧': 'Hood Outer Panel',
    '发动机舱盖内侧': 'Hood Inner Panel',
    '水箱框架': 'Radiator Support Frame',
    '前防撞梁': 'Front Bumper Beam',
    '左前纵梁': 'Left Front Frame Rail',
    '左前翼子板骨架': 'Left Front Fender Apron',
    '左前减震器支座': 'Left Front Strut Tower',
    '防火墙': 'Firewall',
    '车架号': 'VIN Plate',
    '右前减震器支座': 'Right Front Strut Tower',
    '右前翼子板骨架': 'Right Front Fender Apron',
    '右前纵梁': 'Right Front Frame Rail',
    '发动机变速箱及附件': 'Engine, Transmission and Accessories',
    '机油': 'Engine Oil',
    '防冻液': 'Coolant',
    '刹车油': 'Brake Fluid',
    '电池': 'Battery',
    '皮带': 'Belt',
    '保险丝盒': 'Fuse Box',
    '发动机线束': 'Engine Wiring Harness',
    '左前轮胎': 'Left Front Tire',
    '左前轮毂': 'Left Front Wheel Rim',
    '左前避震器': 'Left Front Shock Absorber',
    '左前轮内衬罩': 'Left Front Wheel Arch Liner',
    '左前翼子板': 'Left Front Fender',
    '左后视镜': 'Left Side Mirror',
    '前风挡玻璃': 'Front Windshield',
    '左A柱外侧': 'Left A-Pillar Outer',
    '左前车顶': 'Left Front Roof',
    '左前门玻璃': 'Left Front Door Glass',
    '左前门外侧': 'Left Front Door Outer Panel',
    '左前门裙边外侧': 'Left Front Door Sill Outer',
    '左前门内侧': 'Left Front Door Inner Panel',
    '左前门内饰（含胶条）': 'Left Front Door Trim (incl. Sealing Strips)',
    '左A柱内侧': 'Left A-Pillar Inner',
    '左前门裙边内侧': 'Left Front Door Sill Inner',
    '主驾座椅区域': 'Driver Seat Area',
    '主驾座椅滑轨': 'Driver Seat Track',
    '主驾安全带': 'Driver Seat Belt',
    '左前地毯（含周边饰条、饰板）': 'Left Front Carpet (incl. Surrounding Trim Strips and Panels)',
    '转向管柱': 'Steering Column',
    '方向盘': 'Steering Wheel',
    '仪表盘': 'Instrument Cluster',
    '中控台': 'Center Console',
    '前排扶手区域': 'Front Armrest Area',
    '主驾仪表台': 'Driver Dashboard',
    '左A柱内饰板': 'Left A-Pillar Trim Panel',
    '左前顶棚（含前排天窗饰板、遮阳板）': 'Left Front Headliner (incl. Front Sunroof Trim and Sun Visors)',
    '前排天窗': 'Front Sunroof',
    '内后视镜区域': 'Rearview Mirror Area',
    '左后轮胎': 'Left Rear Tire',
    '左后轮毂': 'Left Rear Wheel Rim',
    '左后避震器': 'Left Rear Shock Absorber',
    '左后轮内衬罩': 'Left Rear Wheel Arch Liner',
    '左后翼子板': 'Left Rear Fender',
    '左C柱外侧': 'Left C-Pillar Outer',
    '左后车顶': 'Left Rear Roof',
    '左B柱外侧': 'Left B-Pillar Outer',
    '左后门玻璃': 'Left Rear Door Glass',
    '左后门外侧': 'Left Rear Door Outer Panel',
    '左后门裙边外侧': 'Left Rear Door Sill Outer',
    '左后门内侧': 'Left Rear Door Inner Panel',
    '左后门内饰（含胶条）': 'Left Rear Door Trim (incl. Sealing Strips)',
    '左C柱内侧': 'Left C-Pillar Inner',
    '左B柱内侧': 'Left B-Pillar Inner',
    '左后门裙边内侧': 'Left Rear Door Sill Inner',
    '左后座椅区域': 'Left Rear Seat Area',
    '左后座椅滑轨': 'Left Rear Seat Track',
    '左后安全带': 'Left Rear Seat Belt',
    '左后地毯（含周边饰条、饰板）': 'Left Rear Carpet (incl. Surrounding Trim Strips and Panels)',
    '后排扶手区域': 'Rear Armrest Area',
    '左B柱内饰板': 'Left B-Pillar Trim Panel',
    '左C柱内饰板': 'Left C-Pillar Trim Panel',
    '左后顶棚（含后排天窗饰板）': 'Left Rear Headliner (incl. Rear Sunroof Trim)',
    '后排天窗': 'Rear Sunroof',
    '后风挡玻璃': 'Rear Windshield',
    '左D柱外侧': 'Left D-Pillar Outer',
    '右D柱外侧': 'Right D-Pillar Outer',
    '后备箱盖外侧': 'Trunk Lid Outer Panel',
    '左后尾灯': 'Left Rear Tail Lamp',
    '右后尾灯': 'Right Rear Tail Lamp',
    '后保险杠': 'Rear Bumper',
    '后防撞梁': 'Rear Bumper Beam',
    '左后纵梁': 'Left Rear Frame Rail',
    '右后纵梁': 'Right Rear Frame Rail',
    '后底盘': 'Rear Underbody',
    '后备箱盖内侧': 'Trunk Lid Inner Panel',
    '后备箱盖内饰板（含胶条）': 'Trunk Lid Trim Panel (incl. Sealing Strips)',
    '后部导水槽': 'Rear Drain Channel',
    '左D柱内饰板': 'Left D-Pillar Trim Panel',
    '左D柱内侧': 'Left D-Pillar Inner',
    '右D柱内饰板': 'Right D-Pillar Trim Panel',
    '右D柱内侧': 'Right D-Pillar Inner',
    '后窗台板': 'Rear Parcel Shelf',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': 'Trunk Trim (incl. Sealing Strips, Carpet and Surrounding Trim Strips and Panels)',
    '后围板': 'Rear End Panel',
    '备胎轮胎': 'Spare Tire',
    '备胎轮毂': 'Spare Wheel Rim',
    '工具': 'Toolkit',
    '后备箱底板': 'Trunk Floor',
    '左后翼子板骨架(包含减震器支座)': 'Left Rear Fender Apron (incl. Strut Tower)',
    '右后翼子板骨架(包含减震器支座)': 'Right Rear Fender Apron (incl. Strut Tower)',
    '右后轮胎': 'Right Rear Tire',
    '右后轮毂': 'Right Rear Wheel Rim',
    '右后避震器': 'Right Rear Shock Absorber',
    '右后轮内衬罩': 'Right Rear Wheel Arch Liner',
    '右后翼子板': 'Right Rear Fender',
    '右C柱外侧': 'Right C-Pillar Outer',
    '右后车顶': 'Right Rear Roof',
    '右B柱外侧': 'Right B-Pillar Outer',
    '右后门玻璃': 'Right Rear Door Glass',
    '右后门外侧': 'Right Rear Door Outer Panel',
    '右后门裙边外侧': 'Right Rear Door Sill Outer',
    '右后门内侧': 'Right Rear Door Inner Panel',
    '右后门内饰（含胶条）': 'Right Rear Door Trim (incl. Sealing Strips)',
    '右C柱内侧': 'Right C-Pillar Inner',
    '右B柱内侧': 'Right B-Pillar Inner',
    '右后门裙边内侧': 'Right Rear Door Sill Inner',
    '右后座椅区域': 'Right Rear Seat Area',
    '右后座椅滑轨': 'Right Rear Seat Track',
    '右后安全带': 'Right Rear Seat Belt',
    '右后地毯（含周边饰条、饰板）': 'Right Rear Carpet (incl. Surrounding Trim Strips and Panels)',
    '右B柱内饰板': 'Right B-Pillar Trim Panel',
    '右C柱内饰板': 'Right C-Pillar Trim Panel',
    '右后顶棚': 'Right Rear Headliner',
    '右A柱外侧': 'Right A-Pillar Outer',
    '右前车顶': 'Right Front Roof',
    '右前门玻璃': 'Right Front Door Glass',
    '右前门外侧': 'Right Front Door Outer Panel',
    '右前门裙边外侧': 'Right Front Door Sill Outer',
    '右前门内侧': 'Right Front Door Inner Panel',
    '右前门内饰（含胶条）': 'Right Front Door Trim (incl. Sealing Strips)',
    '右A柱内侧': 'Right A-Pillar Inner',
    '右前门裙边内侧': 'Right Front Door Sill Inner',
    '副驾座椅区域': 'Passenger Seat Area',
    '副驾座椅滑轨': 'Passenger Seat Track',
    '副驾安全带': 'Passenger Seat Belt',
    '右前地毯（含周边饰条、饰板）': 'Right Front Carpet (incl. Surrounding Trim Strips and Panels)',
    '副驾仪表台': 'Passenger Dashboard',
    '右A柱内饰板': 'Right A-Pillar Trim Panel',
    '杂物箱': 'Glove Box',
    '右前顶棚（含前排天窗饰板、遮阳板）': 'Right Front Headliner (incl. Front Sunroof Trim and Sun Visors)',
    '右前轮胎': 'Right Front Tire',
    '右前轮毂': 'Right Front Wheel Rim',
    '右前避震器': 'Right Front Shock Absorber',
    '右前轮内衬罩': 'Right Front Wheel Arch Liner',
    '右前翼子板': 'Right Front Fender',
    '右后视镜': 'Right Side Mirror',
    '右前大灯': 'Right Front Headlight',
    '右前雾灯': 'Right Front Fog Lamp',
    '启动': 'Starting',
    '变速箱': 'Transmission',
    '排烟': 'Exhaust Smoke',
    '无钥匙进入': 'Keyless Entry',
    '仪表盘功能自检': 'Instrument Cluster Self-Check',
    '转向助力': 'Power Steering',
    '电动后视镜功能': 'Power Mirror Function',
    '中控锁': 'Central Locking',
    '电动吸合门': 'Soft-Close Doors',
    '电动座椅': 'Power Seats',
    '座椅记忆': 'Seat Memory',
    '座椅加热': 'Seat Heating',
    '座椅通风': 'Seat Ventilation',
    '座椅按摩': 'Seat Massage',
    '主驾驶电动门窗总控': 'Driver Power Window Master Control',
    '灯光系统': 'Lighting System',
    '前驻车雷达': 'Front Parking Sensors',
    '后驻车雷达': 'Rear Parking Sensors',
    '倒车影像': 'Reverse Camera',
    '全景摄像头': 'Surround View Camera',
    '可变悬架': 'Adaptive Suspension',
    '车载冰箱': 'In-Car Refrigerator',
    '室内灯': 'Interior Lights',
    '天窗': 'Sunroof',
    '雨刷': 'Windshield Wipers',
    '多功能方向盘': 'Multi-Function Steering Wheel',
    '方向盘换挡拨片': 'Steering Wheel Paddle Shifters',
    '方向盘加热': 'Heated Steering Wheel',
    '方向盘记忆': 'Steering Wheel Memory',
    '空调': 'Air Conditioning',
    '电动门': 'Power Doors',
    '电动车窗': 'Power Windows',
    '后排电动遮阳帘': 'Rear Power Sunshade',
    '后排液晶屏': 'Rear LCD Screen',
    '玻璃顶电动饰板': 'Glass Roof Power Trim',
    '硬顶敞篷': 'Hardtop Convertible',
    '发动机': 'Engine',
    '多媒体系统': 'Multimedia System',
    '动力电池包安装点': 'Power Battery Pack Mounting Points',
    '动力电池包': 'Power Battery Pack',
    '驱动电机(可见部分)': 'Drive Motor (Visible Part)',
    '逆变器(可见部分)': 'Inverter (Visible Part)',
    '车身高压线束(可见部分)': 'High-Voltage Wiring Harness (Visible Part)',
    '随车充电枪': 'Portable Charging Gun',
    '车辆充电口': 'Vehicle Charging Port',
    '增程器': 'Range Extender',
    '动力系统故障码': 'Powertrain Fault Code',
    '车辆充电故障': 'Vehicle Charging Fault',
  },

  // 缺陷名称
  defect: {
    '安装不良': 'Improper Installation',
    '常转': 'Runs Continuously',
    '超出上限': 'Above Upper Limit',
    '闯档': 'Harsh Gear Engagement',
    '篡改': 'Tampered',
    '打齿异响': 'Gear Grinding Noise',
    '打滑': 'Slipping',
    '打磨': 'Polished',
    '灯内异物': 'Foreign Object in Lamp',
    '低于下限': 'Below Lower Limit',
    '断裂': 'Fractured',
    '钣金修复': 'Sheet Metal Repair',
    '改装': 'Modified',
    '更换': 'Replaced',
    '功能失效': 'Non-Functional',
    '鼓包': 'Bulged',
    '故障': 'Fault',
    '后打胶': 'Adapter Applied to Rear',
    '花屏': 'Screen Distortion',
    '划痕': 'Scratched',
    '划伤': 'Scuffed',
    '晃动': 'Loose',
    '变形': 'Deformed',
    '浑浊': 'Cloudy',
    '胶套损坏': 'Rubber Boot Damaged',
    '胶体异常': 'Abnormal Sealant',
    '胶条异常': 'Abnormal Sealing Strip',
    '卡滞': 'Sticking',
    '空转': 'Free Spinning',
    '老化': 'Aged',
    '裂纹': 'Cracked',
    '冒白烟': 'Emitting White Smoke',
    '冒黑烟': 'Emitting Black Smoke',
    '不出风': 'No Airflow',
    '冒蓝烟': 'Emitting Blue Smoke',
    '霉斑': 'Mold Spots',
    '磨损': 'Worn',
    '泥沙': 'Mud and Silt',
    '喷漆': 'Repainted',
    '偏磨': 'Uneven Wear',
    '破裂': 'Ruptured',
    '破损': 'Damaged',
    '启动困难': 'Hard to Start',
    '气囊爆裂': 'Airbag Deployed',
    '不跳档': 'Unable to Shift Gears',
    '切割': 'Cut',
    '缺失': 'Missing',
    '缺损': 'Chipped',
    '缺线': 'Missing Wiring',
    '入档困难': 'Hard to Engage Gear',
    '色差': 'Color Mismatch',
    '烧烫': 'Burned',
    '渗水': 'Water Seepage',
    '渗油': 'Oil Seepage',
    '失效': 'Out of Function',
    '不制冷': 'No Cooling',
    '水雾': 'Water Fog',
    '松动': 'Loosened',
    '松旷': 'Excessive Play',
    '损坏': 'Broken',
    '损伤': 'Damaged Area',
    '塌陷': 'Sunken',
    '调节失效': 'Adjustment Failure',
    '贴膜起泡': 'Film Bubbling',
    '脱档': 'Gear Slipping',
    '污渍': 'Stains',
    '不走车': 'Vehicle Won\'t Move',
    '响应慢': 'Slow Response',
    '修复': 'Repaired',
    '锈蚀': 'Rusted',
    '异味': 'Odor',
    '异响': 'Abnormal Noise',
    '怠速不稳': 'Unstable Idle',
    '怠速过高': 'High Idle Speed',
    '给不上油': 'No Fuel Delivery',
    '加速抖动': 'Shudder on Acceleration',
    '缺缸': 'Misfire',
    '部件缺失': 'Missing Parts',
    '气门异响': 'Valve Noise',
    '内部异响': 'Internal Noise',
    '轮组异响': 'Wheel Assembly Noise',
    '窜气': 'Blow-By',
    '排气异响': 'Exhaust Noise',
    '水渍': 'Water Stain',
    '凹陷': 'Dented',
    '车门更换': 'Door Replaced',
    '拆卸': 'Disassembled',
    '后盖更换': 'Trunk Lid Replaced',
    '机盖更换': 'Hood Replaced',
    '内饰更换': 'Interior Replaced',
    '焊接': 'Welded',
    '开裂': 'Split',
    '剐蹭划伤': 'Scrapes and Scratches',
    '渗漏': 'Leakage',
    '火烧': 'Fire Damage',
    '抖动': 'Shaking',
    '动力电池故障': 'Power Battery Fault',
    '驱动电机故障': 'Drive Motor Fault',
    '其他': 'Others',
    '快充故障': 'Fast Charging Fault',
    '慢充故障': 'Slow Charging Fault',
    '过火': 'Fire Traces',
    '缺气': 'Low Air Pressure',
  },

  // 等级
  grade: {
    'A': 'Grade A',
    'B': 'Grade B',
    'C': 'Grade C',
    'D': 'Grade D',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': 'No exterior parts replaced',
    '外观原漆': 'Original paint',
    '外观无需整备成本': 'No exterior reconditioning cost',
    '内饰正常使用痕迹': 'Normal interior wear',
    '车辆无骨架损伤': 'No skeleton damage',
    '发动机工况无异常': 'Engine condition normal',
    '变速器原地试车无异常': 'Transmission test normal',
  },

  // 通用
  common: {
    '项': 'items',
    '项异常': 'items abnormal',
    '分': 'pts',
    '级': 'Grade',
    '检测': 'Inspection',
    '图片': 'Image',
    '加载失败': 'Load failed',
    '加载中...': 'Loading...',
  },

  // 页面标题
  title: {
    '车况检测': 'Vehicle Condition',
    '综合描述': 'Summary',
    '综合': 'Overall',
  },

  // 提示文案
  tips: {
    '源于出险数据': '(From insurance data)',
    '车辆是否曾进水(漏水/涉水/水泡)': 'Has the vehicle ever been water-damaged (leak/wading/flood):',
    '是': 'Yes',
    '否': 'No',
    '查看原图': 'View Original',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': 'Exterior Scoring Rules',
    '骨架评级规则': 'Skeleton Rating Rules',
    '内饰评分规则': 'Interior Scoring Rules',
    '综合评级规则': 'Overall Rating Rules',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': 'Like-New Exterior Condition',
    '外观较好': 'Good Exterior Condition',
    '外观一般': 'Average Exterior Condition',
    '外观较差': 'Poor Exterior Condition',
    '外观极差': 'Extremely Poor Exterior Condition',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': 'Like-New Interior Condition',
    '内饰较好': 'Good Interior Condition',
    '内饰一般': 'Average Interior Condition',
    '内饰较差': 'Poor Interior Condition',
    '内饰极差': 'Extremely Poor Interior Condition',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': 'No accident damage to structural and reinforcing components of the vehicle.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'No accident damage to structural components; slight accident damage to reinforcing components.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'No accident damage to structural components; severe accident damage to reinforcing components.',
    '车辆结构件有因事故造成的损伤': 'Accident damage to structural components.',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': 'Skeleton grade ≥A, exterior score ≥90, interior score ≥90, no replacement, cutting, rust, mud, water stains, missing parts, mold, burn marks, or mechanical module damage.',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': 'Skeleton grade ≥A, exterior score ≥80, interior score ≥80, no cutting, mud, water stains, mold, rust, etc.',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': 'Skeleton grade ≥B, exterior score >40, interior score >40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': 'Skeleton grade ≥C, exterior score ≥70, interior score ≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': 'Skeleton grade ≥D, exterior score ≥60, interior score ≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': 'Skeleton grade ≥D, exterior score ≥50, interior score ≥40, flood car not allowed.',
    '骨架等级≥D，外观评分<50，内饰评分<40': 'Skeleton grade ≥D, exterior score <50, interior score <40',
  }
}
